"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MomentumMethodologyCopyCopyCopyCopy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="splitcontentwithimage" className="bg-background text-white py-24 overflow-hidden !h-[670px] lg:py-[120px]">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="lg:col-span-6 flex flex-col gap-8">
            <div className="space-y-6">
              <h2 className="font-default tracking-tight leading-tight !font-bold !text-[hsl(0,0%,100%)] !text-4xl ![margin:-90px_0px_24px_20px]">Better Handling the <br />Challenges of Fast Growth</h2>

              <div className="space-y-4">
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">“These guys are deep thinkers.</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">They help me think outside my limitations and the blocks I have created.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">They assist me to see myself based on my potential.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">As I change my view of myself the perceived problem also changes.</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">They are very insightful and make the complex simple and useful.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_0px_20px] md:text-lg">They are truly trusted advisors”<br /><br /><b>Phil Prosser</b><div><b>Founder / CEO Feedback ASAP</b></div><div><br /></div><div>- Secured deals with FedX &amp; McDonalds</div><div><br /><br /></div></p>
                
                
              </div>
            </div>

            <div>
              <Button asChild size="lg" className="text-primary-foreground inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 has-[>svg]:px-4 rounded-full px-8 bg-accent transition-all duration-300 !text-[hsl(0,0%,100%)] !text-base disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover">
                
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-6">
            <div className="bg-muted-dark-background rounded-2xl overflow-hidden shadow-strong border border-border/30 w-3/4 mx-auto -mt-[70px]">
              <img src="https://newmavericks.com/wp-content/uploads/2026/04/phil-prosser.jpg" alt="NewMavericks Strategic Visual" className="block w-full object-contain hover:scale-105 transition-transform duration-700 ease-in-out" />
              
            </div>
            <div className="mt-[25px] flex justify-center">
              <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-base font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-5 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-12 has-[>svg]:px-5 rounded-full px-10 bg-accent transition-all duration-300 !text-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover">
                <Link to="https://www.dropbox.com/s/qgvne19rtt38iiz/Phil%20Prosser%20Letter.pdf?dl=1" newTab>
                  Download Endorsement Letter
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}